import * as generic from '@/store/generic/mutations/result-status.js'
import {ICaseStatus, INotiLawyerActionType, IProsecutionType} from "@/constants/interface";

export function clearError(state, payload) {
  generic.clearError(state, payload)
}

export function setError(state, payload) {
  generic.setError(state, payload)
}

export function setSuccess(state, payload) {
  generic.setSuccess(state, payload)
}

export function setProcessing(state, payload) {
  generic.setProcessing(state, payload)
}

export function setLawyer(state, payload) {
  state.lawyer = payload
}

export function setLawyers(state, payload) {
  state.lawyers = payload
}

export function setLawyerOptions(state, payload) {
  state.lawyerOptions = payload
}

export function delLawyer(state, payload) {
  state.lawyers = state.lawyers.filter(res => res.id !== payload.id)
}

export function setCourt(state, payload) {
  state.court = payload
}

export function setCourts(state, payload) {
  state.courts = payload
}

export function delCourt(state, payload) {
  state.courts = state.courts.filter(res => res.id !== payload.id)
}

export function setProsecutionFilters(state, payload) {
  state.prosecutionFilters = payload
}

export function setProsecution(state, payload) {
  state.prosecution = payload
  state.prosecutionDetails = payload.details
}

export function setProsecutions(state, payload) {
  state.prosecutions = payload
}

export function setProsecutionsByAction(state, payload) {
  if (payload.action === INotiLawyerActionType.waitingLegalAcceptCase) {
    state.prosecutions = payload.prosecutions.filter(res => res.prosecutionType === IProsecutionType.prosecuteCase && res.caseStatus === ICaseStatus.sendInformationContractToLawyer)
  } else if (payload.action === INotiLawyerActionType.waitingLegalAcceptCaseExecution) {
    state.prosecutions = payload.prosecutions.filter(res => res.prosecutionType === IProsecutionType.prosecuteCase && res.caseStatus === ICaseStatus.sendInformationContractToLawyer)
  } else if (payload.action === INotiLawyerActionType.timeIsUpHoldCase) {
    state.prosecutions = payload.prosecutions.filter(res => res.caseStatus === ICaseStatus.holdCase)
  } else {
    state.prosecutions = payload.prosecutions
  }
}

  export function delProsecution(state, payload) {
    state.prosecutions = state.prosecutions.filter(res => res.id !== payload.id)
  }

  export function setProsecutionDetail(state, payload) {
    state.prosecutionDetail = payload
    state.files = payload.files
  }

  export function setProsecutionDetails(state, payload) {
    state.prosecutionDetails = payload
  }

  export function addProsecutionDetail(state, payload) {
    state.prosecutionDetails = [...state.prosecutionDetails, payload];
    let seq = 1;
    for (const prosecutionDetail of state.prosecutionDetails) {
      prosecutionDetail.seq = seq++;
    }
  }

  export function delProsecutionDetail(state, payload) {
    state.prosecutionDetails = state.prosecutionDetails.filter(res => res.id !== payload.id);
    let seq = 1;
    for (const prosecutionDetail of state.prosecutionDetails) {
      prosecutionDetail.seq = seq++;
    }
  }

  export function setFile(state, payload) {
    state.file = payload
  }

  export function setFiles(state, payload) {
    state.files = payload
  }

  export function addFiles(state, payload) {
    state.files = [...state.files, payload]
  }

  export function delFile(state, payload) {
    const files = state.files.filter(res => res.id !== payload.id)
    state.files = files ? files : []
  }
